export default __webpack_public_path__ + "static/SRF 1025 - Product Specifications & Technical Data-be937cf10029dc563ca2ad9115916b4d.pdf";